<p class="alc-lighter-text" translate="metric-reports/dashboard/subtitle-help"></p>

<div class="number-filter-container">
  <p
    class="text-number"
    [translate]="'metric-reports/list/number-of-reports'"
    [translateParams]="{ metric: numberOfMetricReports, verbatim: numberOfVerbatimReports }"></p>
  <mat-divider [vertical]="true" class="divider"></mat-divider>
  <mat-form-field class="filter" appearance="standard">
    <mat-label><span translate="metric-reports/list/filter"></span></mat-label>
    <input matInput #filter (input)="filterByReportName(filter.value)" />
  </mat-form-field>
</div>

<div *ngIf="isLoading" class="alc-spinner-wrapper-in-flow alc-progress-container">
  <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<!--hidden, because when you use ngIf sorting doesn't work-->
<table mat-table [hidden]="isLoading" [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="id">
    <!-- ID Column -->
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate="metric-reports/list/id"></span>
    </th>
    <td mat-cell *matCellDef="let report">
      {{ report.id }}
    </td>
  </ng-container>
  <!-- Report Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate="metric-reports/list/report-title"></span>
    </th>
    <td mat-cell *matCellDef="let report">
      <a (click)="goToAnalyticsPage(report)" [matTooltip]="'metrics-report/list/go-metric' | translate">{{
        report.name
      }}</a>
    </td>
  </ng-container>
  <!-- Sent by email Column -->
  <ng-container matColumnDef="sentByEmail">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate="metric-reports/list/sent-by-email"></span>
    </th>
    <td mat-cell *matCellDef="let report">
      <span *ngIf="report.send_by.email; else none" [translate]="'metric-reports/list/frequency/' + report.when"></span>
      <ng-template #none>
        <span class="alc-lighter-text small-text" translate="metric-reports/list/none"></span>
      </ng-template>
    </td>
  </ng-container>
  <!-- Sent by FTP Column -->
  <ng-container matColumnDef="sentByFTP">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate="metric-reports/list/sent-by-ftp"></span>
    </th>
    <td mat-cell *matCellDef="let report">
      <span *ngIf="report.send_by.ftp; else none" [translate]="'metric-reports/list/frequency/' + report.when"></span>
      <ng-template #none>
        <span #none class="alc-lighter-text small-text" translate="metric-reports/list/none"></span>
      </ng-template>
    </td>
  </ng-container>
  <!-- Created on Column -->
  <ng-container matColumnDef="created_time">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate="metric-reports/list/creation-date"></span>
    </th>
    <td mat-cell *matCellDef="let report">
      <span>{{ report.created_time | dateTimezone: 'short' }}</span>
    </td>
  </ng-container>
  <!-- Created by Column -->
  <ng-container matColumnDef="createdBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <span translate="metric-reports/list/created-by"></span>
    </th>
    <td mat-cell *matCellDef="let report">
      <span>{{ report.ui.createdBy }}</span>
    </td>
  </ng-container>
  <!-- Action Buttons Column -->
  <ng-container matColumnDef="actionsButtons">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let report">
      <button
        mat-icon-button
        color="primary"
        [disabled]="report.ui.isEditionDisabled"
        (click)="editReport(report)"
        [matTooltip]="'metric-reports/list/edit-tooltip' | translate">
        <mat-icon>settings</mat-icon>
      </button>
      <button
        mat-icon-button
        color="warn"
        [disabled]="report.ui.isEditionDisabled"
        (click)="deleteReport(report)"
        [matTooltip]="'metric-reports/list/delete-tooltip' | translate">
        <mat-icon>delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let report; columns: displayedColumns"></tr>
</table>
